export default "__VITE_ASSET__B3738s1y__"